var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2676 17.6758L18.7988 15.332C18.6523 15.2832 18.5059 15.2344 18.3105 15.2344C17.9688 15.2344 17.627 15.4297 17.4316 15.6738L14.9902 18.6523C11.1816 16.8457 8.1543 13.8184 6.34766 10.0098L9.32617 7.56836C9.57031 7.37305 9.76562 7.03125 9.76562 6.64062C9.76562 6.49414 9.7168 6.34766 9.66797 6.20117L7.32422 0.732422C7.12891 0.292969 6.68945 0 6.20117 0C6.15234 0 6.05469 0.0488281 5.95703 0.0488281L0.878906 1.2207C0.341797 1.36719 0 1.80664 0 2.34375C0 14.8926 10.1074 25 22.6562 25C23.1934 25 23.6328 24.6582 23.7793 24.1211L24.9512 19.043C24.9512 18.9453 24.9512 18.8477 24.9512 18.7988C24.9512 18.3105 24.6582 17.8711 24.2676 17.6758Z",
    fill: "#E6A151"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.c46623127e3d9db81371c21d891b226d.svg";
export { ForwardRef as ReactComponent };